import { ServiceHandler, applyQueryConfig } from '../utils/api.utils';
import { standardQuerySerializer } from '../api/serializers/query.serializers';
import { commonDateParamMappings } from '../api/common/mappings';

// Mirrors the remittance search contract (page/size/search/sort/date) — the fir-billing
// /v1/bank-transaction/search endpoint accepts the same Pageable + filter[]/after/before params.
const bankTransactionSearchMappings = [
  { path: 'page' },
  { path: 'size' },
  { path: 'search' },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: { orderBy?: string; order?: string }) => {
      const newOrder = order || 'asc';
      return orderBy ? `${orderBy},${newOrder}` : null;
    },
  },
  ...commonDateParamMappings,
];

export const getBankTransactions = ServiceHandler({
  url: '/api/billing/v1/bank-transaction/search',
  paramsSerializer: (params) =>
    standardQuerySerializer(applyQueryConfig(bankTransactionSearchMappings, params)),
});

// --- HITL resolve of an EXCEPTION/AMBIGUOUS deposit. Path param = bankLineId; POST body via { data }. ---

export const getBankLineCandidates = ServiceHandler({
  url: '/api/billing/v1/bank-transaction/:bankLineId/candidates',
});

export const linkBankLine = ServiceHandler({
  url: '/api/billing/v1/bank-transaction/:bankLineId/link',
  method: 'POST',
});
